// extracted by mini-css-extract-plugin
module.exports = {"container":"OnePercentForThePlanet_container__hkY69","logo":"OnePercentForThePlanet_logo__Ch2Sq","text":"OnePercentForThePlanet_text__HGdy7"};